// extracted by mini-css-extract-plugin
module.exports = {"root":"DeleteAndEditContainer_root__29qNT"};